export default class Land {
    public land: string | null = null;
    public bezeichnung: string | null = null;
    public zeitstempel: string | null = null;

    constructor(data?: Partial<Land>) {
        Object.assign(this, data);
    }
}
